import React from "react";
export const load_game_cutout = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="23.989"
        viewBox="0 0 24 23.989"
    >
        <path
            id="rect2688"
            d="M1.029.058V24.047h24V.058ZM15.159,2.1a1.608,1.608,0,0,1,.675.077c.292.141.187.554.242,1.01.091.757-.082,1.088.616,1.088.744,0,.889-.171.889-1.051,0-1.041.02-1.051,2.009-1.051H21.6l0,2.19c0,2.033-.08,2.256-1.147,3.1l-1.15.907.353,4.467a18.714,18.714,0,0,0,.711,4.7c1.653,1.078,1.862,1.389,2.1,3.125l.252,1.84H4.36l.264-1.838c.249-1.736.449-2.029,2.131-3.127a18.713,18.713,0,0,0,.711-4.7L7.818,8.37l-1.15-.907C5.6,6.621,5.518,6.4,5.521,4.366l0-2.19H7.534c1.989,0,2.009.011,2.009,1.051,0,.888.142,1.051.913,1.051s.913-.162.913-1.069V2.141l2.489-.019c.5,0,.943-.02,1.3-.019Z"
            transform="translate(-1.029 -0.058)"
        />
    </svg>
);
